export default function (store, { id }) {
    const task = store.getTask(id);
    if (task?.collapsed)
        return;
    store.in.exec("update-task", {
        id,
        task: {
            ...task,
            collapsed: true,
        },
        skipProvider: true,
    });
}
//# sourceMappingURL=collapse.js.map